import { extend, configure } from "vee-validate/dist/vee-validate.full";
import { parse } from "vue-currency-input";
import store from "./store/store";

import errorMessages from "./errormessages.json";
window.errorMessages = errorMessages;

const formatter = new Intl.NumberFormat("hu-HU", {
  maximumFractionDigits: 0,
});

configure({
  classes: {
    invalid: "is-invalid",
  },
});

extend("int_required", (value) => {
  if (value == 1) return true;
});

extend("int_not_required", (value) => {
  if (value !== 1) return true;
});

extend("currency_min", {
  validate(value, { min }) {
    if (value >= min) return true;
    if (typeof value !== "string") return false;
    return parse(value, window.currencyInputOptions) >= min;
  },
  params: ["min"],
});

extend("currency_max", {
  validate(value, { max }) {
    if (value <= max) return true;
    if (typeof value !== "string") return false;
    return parse(value, window.currencyInputOptions) <= max;
  },
  params: ["max"],
});

extend("valuables_above_200_min", (value) => {
  const data = store.state.chooseableAccesories;
  if (data.valuesAbove200Sum >= data.valuesAbove200Minimum) return true;
  return `A négy mező értékének el kell érnie a ${formatter.format(
    data.valuesAbove200Minimum,
  )} forintot. Hiányzik: ${formatter.format(
    data.valuesAbove200Minimum - data.valuesAbove200Sum,
  )} Ft.`;
});

extend("valuables_above_200_max", (value) => {
  const data = store.state.chooseableAccesories;
  if (data.valuesAbove200Sum <= data.valuesAbove200Maximum) return true;
});

extend("kockazat_kezdet", (value) => {
  if (!value) return false;

  const tomorrow = new Date(
    new Date().getFullYear(),
    new Date().getMonth(),
    new Date().getDate() + 1,
  );
  const maxDate = new Date(
    tomorrow.getFullYear(),
    tomorrow.getMonth(),
    tomorrow.getDate() + 180,
  );
  const vaueAsDate = new Date(value);

  if (vaueAsDate >= tomorrow && vaueAsDate <= maxDate) return true;
});

extend("temetes_szuletesi_datum", (value) => {
  if (!value) return false;

  const today = new Date(
    new Date().getFullYear(),
    new Date().getMonth(),
    new Date().getDate(),
  );

  const minDate = new Date(
    today.getFullYear() - 65,
    today.getMonth(),
    today.getDate(),
  );

  const valueAsDate = new Date(value);

  if (valueAsDate >= minDate && valueAsDate <= today) return true;

  return false;
});

extend("utas_szuletesi_datum", (value) => {
  if (!value) return false;

  const today = new Date(
    new Date().getFullYear(),
    new Date().getMonth(),
    new Date().getDate(),
  );

  const minDate = new Date(
    today.getFullYear() - 70,
    today.getMonth(),
    today.getDate(),
  );

  const valueAsDate = new Date(value);

  if (valueAsDate >= minDate && valueAsDate <= today) return true;

  return false;
});

extend("szerzodes_szuletes_datum", (value) => {
  if (!value) return false;

  const valueAsDate = new Date(value);

  const now = new Date();
  const today = new Date(now.getFullYear(), now.getMonth(), now.getDate() + 1);

  const minDate = new Date();
  minDate.setFullYear(1900);
  minDate.setMonth(1);
  minDate.setDate(1);
  const maxDate = new Date();
  maxDate.setFullYear(today.getFullYear() - 18);
  maxDate.setMonth(now.getMonth());
  maxDate.setDate(now.getDate());

  return !(valueAsDate > maxDate || valueAsDate < minDate);
});

extend("szuletes_datum", (value) => {
  const now = new Date();
  const today = new Date(now.getFullYear(), now.getMonth(), now.getDate() + 1);
  const minDate = new Date();
  minDate.setFullYear(1900);
  minDate.setMonth(1);
  minDate.setDate(1);

  return !(value > today || value < minDate);
});

extend("zip_code", (_, [city_name]) => {
  if (city_name) {
    if (city_name != "Hibás irányítószám") return true;
  } else {
    if (
      (store.state.generalInfo.propertyName != "Hibás irányítószám" &&
        !Array.isArray(store.state.generalInfo.propertyName)) ||
      (Array.isArray(store.state.generalInfo.propertyName) &&
        store.state.generalInfo.propertyName)
    )
      return true;
  }
});

extend("zipcode", (value) => {
  const valueAsString = value.toString();
  if (valueAsString.length === 4 && store.state.cities?.[valueAsString])
    return true;
  return false;
});

extend("email_verify_code", (value) => {
  if (btoa(value) == store.state.email_valid_code) return true;
});
extend("bankszamlaszam", (value) => {
  const number = value.replaceAll("-", "");
  return number.length === 16 || number.length === 24;
});

extend("bankszamlaszam_alg", (value) => {
  const number = value.replaceAll("-", "");
  let sum = 0;
  for (let i = 0; i < number.length; i++) {
    let multy = [
      9,
      7,
      3,
      1,
      9,
      7,
      3,
      1,
      9,
      7,
      3,
      1,
      9,
      7,
      3,
      1,
      9,
      7,
      3,
      1,
      9,
      7,
      3,
      1,
    ];
    sum += parseInt(number[i]) * multy[i];
  }
  return sum % 10 == 0;
});

extend("required_checkbox", (value) => {
  if (value) return true;
});

extend("temetes_szuletes_datum", (value) => {
  const valueAsDate = new Date(value);

  const today = new Date();
  const minDate = new Date(
    today.getFullYear() - 65,
    today.getMonth(),
    today.getDate(),
  );

  return valueAsDate > minDate && valueAsDate < today;
});

extend("utas_szuletes_datum", (value) => {
  // console.log("validating utas born date")
  const valueAsDate = new Date(value);

  const today = new Date();
  const minDate = new Date(
    today.getFullYear() - 70,
    today.getMonth(),
    today.getDate(),
  );

  // console.log("mindate: " + minDate)

  return valueAsDate >= minDate && valueAsDate <= today;
});
